/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Volume_FirstInputs */

const en_us2_wrapped_volume_first = /** @type {(inputs: Wrapped_Volume_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your first week with volume on record.`)
};

const pt_br2_wrapped_volume_first = /** @type {(inputs: Wrapped_Volume_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua primeira semana com volume registrado.`)
};

const es_419_wrapped_volume_first = /** @type {(inputs: Wrapped_Volume_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu primera semana con volumen registrado.`)
};

const pt_pt2_wrapped_volume_first = /** @type {(inputs: Wrapped_Volume_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua primeira semana com volume registado.`)
};

const fr_fr2_wrapped_volume_first = /** @type {(inputs: Wrapped_Volume_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta première semaine avec du volume enregistré.`)
};

const de_de2_wrapped_volume_first = /** @type {(inputs: Wrapped_Volume_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine erste Woche mit erfasstem Volumen.`)
};

const it_it2_wrapped_volume_first = /** @type {(inputs: Wrapped_Volume_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua prima settimana con volume registrato.`)
};

/**
* | output |
* | --- |
* | "Your first week with volume on record." |
*
* @param {Wrapped_Volume_FirstInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_volume_first = /** @type {((inputs?: Wrapped_Volume_FirstInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Volume_FirstInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_volume_first(inputs)
	if (locale === "es-419") return es_419_wrapped_volume_first(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_volume_first(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_volume_first(inputs)
	if (locale === "de-DE") return de_de2_wrapped_volume_first(inputs)
	if (locale === "it-IT") return it_it2_wrapped_volume_first(inputs)
	return en_us2_wrapped_volume_first(inputs)
});
export { wrapped_volume_first as "wrapped.volume_first" }